import { type FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { QuestionItems } from '../questionItems/QuestionItems';

import { type RelatedQuestionItems_question$data } from './__generated__/RelatedQuestionItems_question.graphql';

type Props = {
    question: RelatedQuestionItems_question$data;
};

const MAX_RELATED_ITEMS = 6;

const RelatedQuestionItemsComponent: FunctionComponent<Props> = ({ question }) => {
    const relatedQuestionItems =
        question?.relatedQuestionItems?.edges?.slice(0, MAX_RELATED_ITEMS) || [];
    const { primaryPage } = question;

    if (primaryPage?.url && primaryPage?.title) {
        return (
            <QuestionItems
                items={relatedQuestionItems}
                url={primaryPage.url}
                title={primaryPage.title}
            />
        );
    }

    return null;
};

export const RelatedQuestionItems = createFragmentContainer(RelatedQuestionItemsComponent, {
    question: graphql`
        fragment RelatedQuestionItems_question on QuestionType {
            primaryPage {
                url
                title
            }
            relatedQuestionItems {
                edges {
                    node {
                        item {
                            ...ItemTile_item
                            serviceId
                            title
                        }
                    }
                }
            }
        }
    `,
});
